// Bileli · modules/account/model — PURE profile-name validation (no Teact, no global imports; unit-tested).
// Mirrors the backend DisplayNameValidator so we never PATCH a value the server will 400 on.

/**
 * Whether a name is submittable to PATCH /me/profile: 2–80 chars, MUST contain a letter (so a pure-emoji
 * Telegram name like "🫪" is rejected), and the literal "Personal" is the reserved publish sentinel.
 */
export function isUsableProfileName(name: string): boolean {
  const n = name.trim();
  return n.length >= 2 && n.length <= 80 && /\p{L}/u.test(n) && n.toLowerCase() !== 'personal';
}
